import { render } from "./FormMultipleButtonsFieldComponent.vue?vue&type=template&id=1639093e&scoped=true"
import script from "./FormMultipleButtonsFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormMultipleButtonsFieldComponent.vue?vue&type=script&lang=js"

import "./FormMultipleButtonsFieldComponent.vue?vue&type=style&index=0&id=1639093e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1639093e"]])

export default __exports__